import React, { createContext, useMemo, useReducer } from 'react';
export const Context = createContext(undefined);
Context.displayName = 'UIContext';
const baseInitialState = {
    displayMinicart: false,
};
const reducer = (actions) => {
    const allActions = {
        OPEN_MINICART: (state) => ({
            ...state,
            displayMinicart: true,
        }),
        CLOSE_MINICART: (state) => ({
            ...state,
            displayMinicart: false,
        }),
        ...actions,
    };
    return (state, { type, data }) => {
        const maybeAction = allActions[type];
        if (typeof maybeAction === 'function') {
            return maybeAction(state, data);
        }
        throw new Error('Unknown UI state');
    };
};
const defaultEffects = () => ({});
export const Provider = ({ children, actions = {}, effects = defaultEffects, initialState = {}, }) => {
    const [state, dispatch] = useReducer(reducer(actions), {
        ...baseInitialState,
        ...initialState,
    });
    const effectsValue = useMemo(() => ({
        ...effects(dispatch),
        openMinicart: () => dispatch({ type: 'OPEN_MINICART' }),
        closeMinicart: () => dispatch({ type: 'CLOSE_MINICART' }),
    }), [effects]);
    const value = useMemo(() => ({
        ...state,
        ...effectsValue,
    }), [effectsValue, state]);
    return React.createElement(Context.Provider, { value: value }, children);
};
//# sourceMappingURL=Provider.js.map